import Request from '@/utils/request'

export function getActBaseInfo () {
  return Request({
    url: '/api/v2/app/nis/home',
    method: 'get'
  })
}

export function actRewardClaim1 (cfgId) {
  return Request({
    url: `/api/v2/app/nis/milestone/claim/${cfgId}`,
    method: 'post'
  })
}

export function actRewardClaim2 (taskId) {
  return Request({
    url: `/api/v2/app/nis/task/claim/${taskId}`,
    method: 'post'
  })
}
